import React, { useRef } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Valentina R.',
  location: 'Buenos Aires',
  role: 'Emprendedora de moda en casa',
  pack: 'Pack Full Access',
  text: 'Vendí todo el stock de mi primera compra en 18 días. El guión de ventas por DM lo usé desde el primer día y cambió todo. Antes no sabía qué decir cuando me preguntaban el precio — ahora cierro el 70% de las consultas.'
}, {
  name: 'Luciana M.',
  location: 'Rosario',
  role: 'Showroom y venta por Instagram',
  pack: 'Pack Pro',
  text: 'Llevaba meses postergando porque no sabía dónde conseguir proveedores ni cómo fijar el precio. Con la Guía 2 y la calculadora lo resolví en un fin de semana. Hice mi primera compra en Once con criterio y ya vendí el 80%.'
}, {
  name: 'Magalí T.',
  location: 'Córdoba',
  role: 'Arrancó desde cero',
  pack: 'Pack Inicial',
  text: 'Adapto todo a mi ritmo desde el celular. Nunca había vendido nada y en el primer mes tuve 14 ventas. Ahora estoy armando el showroom. No lo puedo creer.'
}, {
  name: 'Carla S.',
  location: 'Mendoza',
  role: 'Venta por Instagram y WhatsApp',
  pack: 'Pack Full Access',
  text: 'El directorio de proveedores me ahorró meses de prueba y error. Encontré mayoristas que envían a Mendoza con buen precio y ahora mis márgenes son reales. La lista VIP de WhatsApp me trae ventas todas las semanas.'
}, {
  name: 'Daniela P.',
  location: 'La Plata',
  role: 'Showroom en casa',
  pack: 'Pack Pro',
  text: 'Lo que más me sirvió fue la planilla de números. Antes vendía y no sabía si ganaba. Ahora sé exactamente mi margen en cada prenda y dejé de regalar mi trabajo. En dos meses dupliqué mis ingresos.'
}, {
  name: 'Sofía G.',
  location: 'Salta',
  role: 'Arrancó desde cero',
  pack: 'Pack Full Access',
  text: 'Vivo en el interior y pensaba que era imposible. Con el calendario de contenido y los textos listos para Instagram empecé a publicar todos los días sin bloquearme. Hoy tengo clientas fieles que me recomiendan solas.'
}];
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    const container = scrollRef.current;
    if (!container) return;
    const card = container.querySelector<HTMLElement>('[data-card]');
    const amount = card ? card.offsetWidth + 16 : container.clientWidth * 0.8;
    container.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  };
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/20" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="flex items-end justify-between mb-6 sm:mb-8" data-id="element-273">
          <div data-id="element-274">
            <p className="text-gold text-xs sm:text-sm tracking-widest mb-2 sm:mb-3" data-id="element-275">
              OPINIONES Y CASOS DE ÉXITO
            </p>
            <h2 className="font-display text-2xl sm:text-4xl font-bold text-white" data-id="element-276">
              Lo que dicen las emprendedoras
            </h2>
          </div>
          <div className="hidden sm:flex gap-2 flex-shrink-0" data-id="element-277">
            <button onClick={() => scroll('left')} aria-label="Ver opiniones anteriores" className="w-11 h-11 rounded-full border border-gold/30 text-gold flex items-center justify-center hover:bg-gold/10 hover:border-gold/50 transition-colors focus:outline-none focus:ring-2 focus:ring-gold/50" data-id="element-278">
              <ChevronLeft className="w-5 h-5" data-id="element-279" />
            </button>
            <button onClick={() => scroll('right')} aria-label="Ver más opiniones" className="w-11 h-11 rounded-full border border-gold/30 text-gold flex items-center justify-center hover:bg-gold/10 hover:border-gold/50 transition-colors focus:outline-none focus:ring-2 focus:ring-gold/50" data-id="element-280">
              <ChevronRight className="w-5 h-5" data-id="element-281" />
            </button>
          </div>
        </div>

        <div ref={scrollRef} className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 -mx-4 px-4 sm:mx-0 sm:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-282">
          {testimonials.map((testimonial, index) => <motion.div key={index} data-card initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} whileHover={{
          y: -4,
          boxShadow: '0 10px 30px -10px rgba(212, 175, 55, 0.15)'
        }} whileTap={{
          scale: 0.98
        }} className="snap-start flex-shrink-0 w-[80%] sm:w-[340px] bg-violet-deep/60 border border-gold/20 rounded-lg p-4 sm:p-6 hover:border-gold/40 transition-colors duration-300 cursor-default" data-id="element-283">
              <div className="flex gap-1 mb-3 sm:mb-4" data-id="element-284">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 sm:w-4 sm:h-4 fill-gold text-gold" data-id="element-285" />)}
              </div>
              <p className="text-violet-100/90 text-sm sm:text-base mb-3 sm:mb-4 leading-relaxed" data-id="element-286">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gold/10 pt-3 sm:pt-4" data-id="element-287">
                <p className="font-semibold text-white text-sm sm:text-base" data-id="element-288">
                  {testimonial.name}
                </p>
                <p className="text-[10px] sm:text-xs text-violet-100/60" data-id="element-289">
                  {testimonial.location} — {testimonial.role}
                </p>
                <p className="text-[10px] sm:text-xs text-gold/80 mt-1" data-id="element-290">
                  [{testimonial.pack}]
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-[10px] sm:hidden text-violet-100/50 mt-1" data-id="element-291">
          Deslizá para ver más →
        </p>
      </div>
    </section>;
}